import { styled } from "@mui/material";
import {ExNyRoute, ExRoute, CoRoute, AcRoute, MiRoute, PrRoute} from '../../../../utils/allRouteId';
import {RouteResponse} from '../../../../types/index';
import {FetchAllRoutes, reOrderFetchedData, filterRouteName} from '../../../../hooks/FetchData';

interface ComponentProps {
    MaxYears: number;
    MinYears: number;
    Score: number;
    ScoreTypeId: number;
    RouteId: number;
}



 

const ViewRoleContent : React.FC<ComponentProps> = ({ ScoreTypeId, Score, MaxYears, MinYears, RouteId }) => {


    const {data: allRoutesData} = FetchAllRoutes();
    const reOrderedAllRoutes = allRoutesData ? reOrderFetchedData((allRoutesData as RouteResponse )?.Data) : []
      
    return (
        <StyledContainer>
            <StyledWrapper>
                <StyledText2>Score</StyledText2>
                <Active>{Score}</Active>
            </StyledWrapper>
            <StyledWrapper>
                <StyledText2>Year Range</StyledText2>
                <StyledDate> {`${MaxYears} - ${MinYears} Years`}</StyledDate>
            </StyledWrapper>
            <StyledWrapper>
                <StyledText2>Route</StyledText2>
                <StyledText>{filterRouteName(RouteId, reOrderedAllRoutes)}</StyledText>
            </StyledWrapper>
            <StyledWrapper>
                
            </StyledWrapper>
        </StyledContainer>
    )
}

export default ViewRoleContent;

const StyledContainer = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 2rem;
    padding-block-start: 3rem;
    padding-block-end: 5rem;
    padding-inline: 2rem;
`

const StyledWrapper = styled('div')`
    display: flex;
    justify-content: space-between;
`

const StyledText = styled('span')`
    font-size: 24px;
    font-weight: 400;
    color: #4E5A62;
    width: 60%;
    text-align: right;
`
const StyledText2 = styled('span')`
    font-size: 24px;
    font-weight: 500;
    color: #020D08;
    width:100%
`

const Active = styled('span')`
    font-size: 16px;
    font-weight: 500;
    background-color: #E0FAEE;
    border-radius: 0.4rem;
    padding-inline: 2rem;
    padding-block: 0.5rem;
    color: #11643C;
`

const StyledDate = styled(StyledText)`
    color: #020D08;
    font-weight: 500;
`